/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { TagGroupDefinitionWithLinks } from '../models/tag-group-definition-with-links';
@Injectable({
  providedIn: 'root',
})
class TagGroupDefinitionsWithLinksService extends __BaseService {
  static readonly TagGroupDefinitionsWithLinksGetPath = '/tag-group-definitions-with-links/{tagGroupDefinitionId}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Returns the tag group definition with links
   * @param params The `TagGroupDefinitionsWithLinksService.TagGroupDefinitionsWithLinksGetParams` containing the following parameters:
   *
   * - `tagGroupDefinitionId`: GUID of the tag group definition
   *
   * - `Authorization`: Bearer JSON Web Token
   *
   * @return OK
   */
  TagGroupDefinitionsWithLinksGetResponse(params: TagGroupDefinitionsWithLinksService.TagGroupDefinitionsWithLinksGetParams): __Observable<__StrictHttpResponse<TagGroupDefinitionWithLinks>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/tag-group-definitions-with-links/${encodeURIComponent(String(params.tagGroupDefinitionId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<TagGroupDefinitionWithLinks>;
      })
    );
  }
  /**
   * Returns the tag group definition with links
   * @param params The `TagGroupDefinitionsWithLinksService.TagGroupDefinitionsWithLinksGetParams` containing the following parameters:
   *
   * - `tagGroupDefinitionId`: GUID of the tag group definition
   *
   * - `Authorization`: Bearer JSON Web Token
   *
   * @return OK
   */
  TagGroupDefinitionsWithLinksGet(params: TagGroupDefinitionsWithLinksService.TagGroupDefinitionsWithLinksGetParams): __Observable<TagGroupDefinitionWithLinks> {
    return this.TagGroupDefinitionsWithLinksGetResponse(params).pipe(
      __map(_r => _r.body as TagGroupDefinitionWithLinks)
    );
  }
}

namespace TagGroupDefinitionsWithLinksService {

  /**
   * Parameters for TagGroupDefinitionsWithLinksGet
   */
  export interface TagGroupDefinitionsWithLinksGetParams {

    /**
     * GUID of the tag group definition
     */
    tagGroupDefinitionId: string;

    /**
     * Bearer JSON Web Token
     */
    Authorization: string;
  }
}

export { TagGroupDefinitionsWithLinksService }